module.exports = __webpack_public_path__ + "img/der_01_coin.9162556f.png";